import { render } from "./GreenifiedButton.vue?vue&type=template&id=01bc4d8f&scoped=true"
import script from "./GreenifiedButton.vue?vue&type=script&lang=js"
export * from "./GreenifiedButton.vue?vue&type=script&lang=js"

import "./GreenifiedButton.vue?vue&type=style&index=0&id=01bc4d8f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01bc4d8f"]])

export default __exports__